class VariantInput extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("change", () => {
      this.data = window.scrapeSectionData(this);
      this.dispatchEvent(
        new CustomEvent("variant:changed", {
          bubbles: true,
          detail: { variant: this.data.variant, variantData: this.data.variant_data },
        })
      );
    });
  }

  disconnectedCallback() { }
}

if (!customElements.get("variant-input")) {
  customElements.define("variant-input", VariantInput);
}
